/* The optional collection upsell must do no work when no collection products exist. */
(() => {
  const source = document.getElementById('cart-drawer-upsell-wrapper');
  if (!source) return;
  source.hidden = true;
  if (!source.querySelector('.cart-drawer-upsell-list-item')) return;
  let currentHTML = source.innerHTML;
  let pending = null;
  function render() {
    const drawer = document.querySelector('cart-drawer');
    const items = drawer?.querySelector('cart-drawer-items');
    if (!drawer || !items) return;
    drawer.querySelector('[data-prink-collection-upsell]')?.remove();
    if (items.classList.contains('is-empty') || !items.querySelector('.cart-item')) return;
    const content = document.createElement('div');
    content.innerHTML = currentHTML;
    const upsell = content.querySelector('#cart-drawer-upsell');
    if (!upsell || !upsell.querySelector('.cart-drawer-upsell-list-item')) return;
    upsell.id = 'prink-collection-upsell';
    upsell.dataset.prinkCollectionUpsell = 'true';
    upsell.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
    let wrapper = items.parentElement;
    if (!wrapper.classList.contains('cart-drawer-items-wrapper')) {
      wrapper = document.createElement('div');
      wrapper.className = 'cart-drawer-items-wrapper';
      items.before(wrapper);
      wrapper.appendChild(items);
    }
    wrapper.appendChild(upsell);
  }
  function useSections(sections) {
    if (!sections || typeof sections['cart-drawer'] !== 'string') return false;
    const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = doc.getElementById('cart-drawer-upsell-wrapper');
    if (!fresh) return false;
    currentHTML = fresh.innerHTML;
    render();
    return true;
  }
  async function refresh(sections) {
    if (useSections(sections) || pending) return;
    pending = (async () => {
      try {
        const url = new URL(window.routes.cart_url, window.location.origin);
        url.searchParams.set('sections', 'cart-drawer');
        const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        useSections(await response.json());
      } catch (error) { console.error(error); }
      finally { pending = null; }
    })();
    await pending;
  }
  window.onChangeKsUpsellVariantSelector = function(select, event) {
    event.preventDefault();
    const image = select.closest('.cart-drawer-upsell-list-item')?.querySelector('img');
    const src = select.selectedOptions[0]?.dataset.variantImg;
    if (image && src) image.src = src;
  };
  document.addEventListener('prink:cart-rendered', (event) => refresh(event.detail?.sections));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => refresh(event.cartData?.sections));
  }
  render();
})();
